import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Colgroup = ({ columns }) => (
  <colgroup>
    {columns.map((column) => (
      <col key={column.id} className={classNames(column.id)} />
    ))}
  </colgroup>
);

Colgroup.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Colgroup;
